import { render, staticRenderFns } from "./changePassword.vue?vue&type=template&id=215515a4&scoped=true&"
import script from "./changePassword.vue?vue&type=script&lang=js&"
export * from "./changePassword.vue?vue&type=script&lang=js&"
import style0 from "./changePassword.vue?vue&type=style&index=0&id=215515a4&prod&lang=scss&scoped=true&"
import style1 from "./changePassword.vue?vue&type=style&index=1&id=215515a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215515a4",
  null
  
)

export default component.exports